import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { getShipbackPrice } from '../assets/utils'

import { POSTAL, DROPOFF, PICKUP, INSTRUCTIONS, TRACKING, COMPUTED } from '../assets/constant'

var propsInterval = 0;
class SummaryPrice extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.setPrice = this.setPrice.bind(this)
    this.state = { price: null }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.mode != nextProps.mode) {
      propsInterval = setInterval(() => {  this.setPrice(this.props.mode) }, 300)
    }
    if (nextProps.breadcrumb == INSTRUCTIONS || nextProps.breadcrumb == TRACKING) {
      this.setState({price: this.props.shipback.customer_price_cents})
      clearInterval(propsInterval)
    }
  }

  setPrice(mode) {
    if (this.props.shipback.quotes != undefined) {
      this.setState({price: getShipbackPrice(this.props.shipback.quotes, mode)})
      clearInterval(propsInterval)
    }
  }

  render() {
    if (this.props.shipback.quotes != undefined && this.state.price != null) {
    return (
      <div className="price">
        <h3>{I18n.t('layouts.summary.price.title')}</h3>
        <p className="value">
          {
            this.state.price == 0 ?
            I18n.t('layouts.summary.price.free')
            :
            Number(this.state.price / 100).toFixed(2) + " €"
          }
        </p>
      </div>
    )
    } else {
      return (<div></div>)
    }
  }
}

const mapStateToProps = state => ({
  user_token: state.user,
  mode: state.shipback.mode,
  shipback: state.shipback,
  breadcrumb: state.breadcrumb
})

const mapDispatchToProps = dispatch => bindActionCreators({ }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPrice)


// WEBPACK FOOTER //
// ./app/javascript/components/components/SummaryPrice.jsx